module.exports = __webpack_public_path__ + "static/media/gallery-addBlack.8f74b510.svg";